/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import useGoalInfo from '@api/hooks/goal/useGoalInfo';
import PrepLadderIconicSection from './PrepLadderIconicSection';
import GeneralIconicSection from './GeneralIconicSection';

const IconicSection = (props) => {
  const { goalUID } = props;
  const { goalInfo: { externalAppsAvailable } = {} } = useGoalInfo(goalUID);

  return externalAppsAvailable && externalAppsAvailable.length ? (
    <PrepLadderIconicSection {...props} />
  ) : (
    <GeneralIconicSection {...props} />
  );
};

IconicSection.propTypes = {
  goalUID: PropTypes.string.isRequired
};

export default IconicSection;
